// src/pages/HomePage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const NAVY = '#0f172a';
const NAVYD = '#020617';
const BLUE = '#2563eb';
const LIGHT_BLUE = '#3b82f6';
const CYAN = '#06b6d4';
const INDIGO = '#4f46e5';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const openTg = () => window.open('https://t.me/thymuoyhak', '_blank');

  const features = [
    { icon: 'fa-mobile-screen', title: 'ងាយស្រួលប្រើ', desc: 'ដំណើរការល្អនៅលើទូរស័ព្ទ និងកុំព្យូទ័រគ្រប់ប្រភេទ' },
    { icon: 'fa-bolt', title: 'បញ្ជាទិញរហ័ស', desc: 'ចុចតែម្ដង ទៅ Telegram ការបញ្ជាទិញបានភ្លាមៗ' },
    { icon: 'fa-money-bill-wave', title: 'តម្លៃសមរម្យ', desc: 'តម្លៃប្រកួតប្រជែង ជាមួយការផ្ដល់ជូនពិសេសប្រចាំថ្ងៃ' },
    { icon: 'fa-shield-halved', title: 'សុវត្ថិភាព', desc: 'ប្រព័ន្ធទិន្នន័យមានសុវត្ថិភាព និងអាចទុកចិត្តបាន' },
    { icon: 'fa-chart-simple', title: 'គ្រប់គ្រងងាយ', desc: 'គ្រប់គ្រងហាង និងម៉ឺនុយរបស់អ្នកបានយ៉ាងងាយស្រួល' },
    { icon: 'fa-rocket', title: 'ចាប់ផ្តើមរហ័ស', desc: 'បង្កើតហាងឌីជីថលរបស់អ្នកក្នុងរយៈពេល ៥ នាទី' },
  ];

  const stats = [
    { number: '500+', label: 'ការបញ្ជាទិញ/ថ្ងៃ', icon: 'fa-cart-shopping' },
    { number: '4.9★', label: 'ការវាយតម្លៃ', icon: 'fa-star' },
    { number: '30 នាទី', label: 'ដឹកជញ្ជូន', icon: 'fa-truck-fast' },
    { number: '100+', label: 'ហាងចូលរួម', icon: 'fa-store' },
  ];

  const pricing = [
    { 
      name: 'ប្រចាំខែ', 
      price: '$9.99', 
      period: '/ ខែ',
      products: '៥០ ផលិតផល',
      features: [
        'ម៉ឺនុយឌីជីថលពេញលេញ',
        'បង្ហាញផលិតផល ៥០',
        'ទំនាក់ទំនង Telegram',
        'ការគាំទ្រមូលដ្ឋាន',
        'ធ្វើបច្ចុប្បន្នភាពឥតគិតថ្លៃ'
      ],
      popular: false,
      icon: 'fa-crown',
      color: '#3b82f6',
      tag: 'ចាប់ផ្តើម'
    },
    { 
      name: 'ប្រចាំត្រីមាស', 
      price: '$29.99', 
      period: '/ ៣ ខែ',
      products: '៧៥ ផលិតផល',
      features: [
        'ម៉ឺនុយឌីជីថលពេញលេញ',
        'បង្ហាញផលិតផល ៧៥',
        'ទំនាក់ទំនងគ្រប់បណ្តាញ',
        'ការគាំទ្រប្រចាំថ្ងៃ',
        'សន្សំ ២០% បើធៀបនឹងប្រចាំខែ'
      ],
      popular: true,
      icon: 'fa-gem',
      color: '#8b5cf6',
      tag: 'ពេញនិយម'
    },
    { 
      name: 'ប្រចាំឆ្នាំ', 
      price: '$99.99', 
      period: '/ ឆ្នាំ',
      products: '១៥០ ផលិតផល',
      features: [
        'ម៉ឺនុយឌីជីថលពេញលេញ',
        'បង្ហាញផលិតផល ១៥០',
        'ទំនាក់ទំនងគ្រប់បណ្តាញ',
        'ការគាំទ្រ ២៤/៧',
        'ផ្ទាល់ខ្លួនហាង',
        'សន្សំ ៤០% បើធៀបនឹងប្រចាំខែ'
      ],
      popular: false,
      icon: 'fa-building',
      color: '#06b6d4',
      tag: 'សន្សំសំចៃ'
    },
  ];

  const testimonials = [
    { name: 'សុខ សុភ័ក្រ', text: 'ហាងរបស់ខ្ញុំមានការបញ្ជាទិញកើនឡើង ៣០០% បន្ទាប់ពីប្រើប្រាស់សេវាកម្មនេះ', rating: 5 },
    { name: 'ចាន់ សុផល', text: 'ងាយស្រួលប្រើ និងមានប្រសិទ្ធភាពខ្ពស់។ ខ្ញុំសូមណែនាំ!', rating: 5 },
    { name: 'រ៉ន វណ្ណា', text: 'សេវាកម្មល្អ ការគាំទ្រឆ្លើយតបរហ័ស និងមានប្រយោជន៍', rating: 5 },
  ];

  const steps = [
    { number: '01', title: 'ចុះឈ្មោះ', desc: 'បង្កើតគណនីរបស់អ្នកដោយឥតគិតថ្លៃ', icon: 'fa-user-plus' },
    { number: '02', title: 'បង្កើតម៉ឺនុយ', desc: 'បន្ថែមផលិតផល និងតម្លៃរបស់អ្នក', icon: 'fa-utensils' },
    { number: '03', title: 'ចែករំលែក', desc: 'ចែករំលែកតំណហាងរបស់អ្នកទៅកាន់អតិថិជន', icon: 'fa-share-nodes' },
    { number: '04', title: 'ចាប់ផ្តើមលក់', desc: 'ទទួលការបញ្ជាទិញតាម Telegram ភ្លាមៗ', icon: 'fa-hand-holding-dollar' },
  ];

  return (
    <div style={s.root}>
      <style>{GLOBAL}</style>

      {/* ══════════ NAV ══════════ */}
      <nav style={{
        ...s.nav,
        boxShadow: scrolled ? '0 2px 20px rgba(37,99,235,.12)' : 'none',
        borderBottom: scrolled ? `1px solid rgba(37,99,235,.08)` : 'none',
      }}>
        <div style={s.navInner}>
          <Link to="/" style={s.brand}>
            <span style={s.brandDot} />
            <span style={s.brandName}>Menu Khmer Digital</span>
          </Link>
          <div style={s.navRight}>
            <Link to="/demo_store1" style={s.navLink} className="nav-link">ហាងសាកល្បង</Link>
            <Link to="#pricing" style={s.navLink} className="nav-link">តម្លៃ</Link>
            <button style={s.btnBlue} className="btn-blue" onClick={openTg}>
              <i className="fab fa-telegram-plane" style={{ marginRight: 6 }}></i>
              ទំនាក់ទំនង
            </button>
          </div>
        </div>
      </nav>

      {/* ══════════ HERO ══════════ */}
      <section style={s.hero}>
        <div style={s.heroBg}>
          <div style={s.heroGlow1}></div>
          <div style={s.heroGlow2}></div>
        </div>
        <div style={s.heroInner}>
          <div style={s.heroLeft}>
            <span style={s.heroBadge}>🚀&nbsp; បើកហាងឥឡូវនេះ</span>
            <h1 style={s.h1}>
              បង្កើតហាង<br />
              <span style={{ color: BLUE }}>ឌីជីថល</span> របស់អ្នក<br />
              ក្នុងរយៈពេល ៥ នាទី
            </h1>
            <p style={s.heroSub}>
              វេទិកាដ៏ទំនើបសម្រាប់អាជីវកម្មខ្មែរ ងាយស្រួលប្រើ និងឥតគិតថ្លៃ។
              បង្កើតម៉ឺនុយឌីជីថល ទទួលការបញ្ជាទិញតាម Telegram និងបង្កើនការលក់របស់អ្នក។
            </p>
            <div style={s.heroBtns}>
              <button style={s.btnBlue} className="btn-blue" onClick={openTg}>
                <i className="fab fa-telegram-plane" style={{ marginRight: 8 }}></i>
                ចាប់ផ្តើមឥឡូវនេះ
              </button>
              <Link to="/demo_store1" style={s.btnGhost} className="btn-ghost">
                <i className="fas fa-eye" style={{ marginRight: 8 }}></i>
                មើលហាងសាកល្បង
              </Link>
            </div>
            <div style={s.heroTrust}>
              <span><i className="fas fa-check-circle" style={{ color: '#22c55e', marginRight: 4 }}></i> ឥតគិតថ្លៃ</span>
              <span><i className="fas fa-check-circle" style={{ color: '#22c55e', marginRight: 4 }}></i> គ្មានកាត</span>
              <span><i className="fas fa-check-circle" style={{ color: '#22c55e', marginRight: 4 }}></i> ចាប់ផ្តើមភ្លាម</span>
            </div>
          </div>

          <div style={s.heroRight}>
            <div style={s.demoCard}>
              <div style={s.demoCardHeader}>
                <div style={s.demoDots}>
                  <span style={{ background: '#ef4444' }}></span>
                  <span style={{ background: '#f59e0b' }}></span>
                  <span style={{ background: '#22c55e' }}></span>
                </div>
                <span style={s.demoCardTitle}>ម៉ឺនុយឌីជីថល</span>
              </div>
              <div style={s.demoCardBody}>
                <div style={s.demoItem}>
                  <span>🥗 សាឡាត់បន្លែ</span>
                  <span style={{ color: BLUE, fontWeight: 700 }}>$4.50</span>
                </div>
                <div style={s.demoItem}>
                  <span>🍜 គុយទាវសាច់គោ</span>
                  <span style={{ color: BLUE, fontWeight: 700 }}>$5.00</span>
                </div>
                <div style={s.demoItem}>
                  <span>🍮 បង្អែមសណ្តែក</span>
                  <span style={{ color: BLUE, fontWeight: 700 }}>$3.00</span>
                </div>
                <div style={s.demoItem}>
                  <span>☕ កាហ្វេខ្មៅ</span>
                  <span style={{ color: BLUE, fontWeight: 700 }}>$2.00</span>
                </div>
                <div style={s.demoTotal}>
                  <span>សរុប</span>
                  <span style={{ color: BLUE, fontWeight: 700, fontSize: 18 }}>$14.50</span>
                </div>
                <button style={s.demoBtn} className="demo-btn" onClick={openTg}>
                  <i className="fab fa-telegram-plane"></i> បញ្ជាទិញតាម Telegram
                </button>
              </div>
            </div>
          </div>
        </div>

        <div style={s.statsBar}>
          <div style={s.statsInner}>
            {stats.map((stat, i) => (
              <div key={i} style={s.statItem}>
                <i className={`fas ${stat.icon}`} style={s.statIcon}></i>
                <div style={s.statNum}>{stat.number}</div>
                <div style={s.statLbl}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ HOW IT WORKS ══════════ */}
      <section style={s.section}>
        <div style={s.container}>
          <p style={s.eyebrow}>ចាប់ផ្តើមងាយៗ</p>
          <h2 style={s.h2}>
            ដំណើរការ <span style={{ color: BLUE }}>៤ ជំហាន</span> សាមញ្ញ
          </h2>
          <div style={s.stepsGrid}>
            {steps.map((step, i) => (
              <div key={i} style={s.stepCard} className="step-card">
                <div style={s.stepNumber}>{step.number}</div>
                <div style={s.stepIcon}><i className={`fas ${step.icon}`}></i></div>
                <h3 style={s.stepTitle}>{step.title}</h3>
                <p style={s.stepDesc}>{step.desc}</p>
                {i < steps.length - 1 && <div style={s.stepArrow}>→</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ FEATURES ══════════ */}
      <section style={{ ...s.section, background: '#f8fafc' }}>
        <div style={s.container}>
          <p style={s.eyebrow}>មុខងារពិសេស</p>
          <h2 style={s.h2}>
            ហេតុអ្វីត្រូវជ្រើស <span style={{ color: BLUE }}>Menu Khmer Digital</span>
          </h2>
          <div style={s.grid3}>
            {features.map((f, i) => (
              <div key={i} style={s.featCard} className="feat-card">
                <div style={s.featIcon}><i className={`fas ${f.icon}`}></i></div>
                <h3 style={s.featTitle}>{f.title}</h3>
                <p style={s.featDesc}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ TESTIMONIALS ══════════ */}
      <section style={s.section}>
        <div style={s.container}>
          <p style={s.eyebrow}>អតិថិជនពេញចិត្ត</p>
          <h2 style={s.h2}>
            អ្វីដែលអតិថិជន <span style={{ color: BLUE }}>និយាយអំពីយើង</span>
          </h2>
          <div style={s.testimonialsGrid}>
            {testimonials.map((t, i) => (
              <div key={i} style={s.testimonialCard} className="testimonial-card">
                <div style={s.testimonialStars}>
                  {[...Array(5)].map((_, j) => (
                    <span key={j} style={{ color: '#f59e0b' }}>★</span>
                  ))}
                </div>
                <p style={s.testimonialText}>"{t.text}"</p>
                <div style={s.testimonialAuthor}>
                  <div style={s.testimonialAvatar}>{t.name.charAt(0)}</div>
                  <div>
                    <div style={s.testimonialName}>{t.name}</div>
                    <div style={s.testimonialRole}>អតិថិជន</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ PRICING ══════════ */}
      <section id="pricing" style={{ ...s.section, background: '#f8fafc' }}>
        <div style={s.container}>
          <p style={s.eyebrow}>តម្លៃសេវា</p>
          <h2 style={s.h2}>
            ជ្រើសរើសកញ្ចប់ <span style={{ color: BLUE }}>សមស្របនឹងអ្នក</span>
          </h2>
          <div style={s.pricingGrid}>
            {pricing.map((p, i) => (
              <div key={i} style={{ ...s.pricingCard, ...(p.popular ? s.pricingCardPopular : {}), borderTop: `4px solid ${p.color}` }} className="pricing-card">
                {p.popular && <div style={s.popularBadge}>🔥 {p.tag}</div>}
                {!p.popular && <div style={{ ...s.popularBadge, background: p.color }}>{p.tag}</div>}
                <div style={{ ...s.pricingIcon, color: p.color }}><i className={`fas ${p.icon}`}></i></div>
                <h3 style={s.pricingName}>{p.name}</h3>
                <div style={s.pricingPrice}>{p.price}</div>
                <div style={s.pricingPer}>{p.period}</div>
                <div style={{ ...s.pricingProducts, background: `${p.color}15`, color: p.color }}>{p.products}</div>
                <ul style={s.pricingFeatures}>
                  {p.features.map((f, j) => (
                    <li key={j} style={s.pricingFeature}>
                      <i className="fas fa-check-circle" style={{ color: p.color, marginRight: 8 }}></i> {f}
                    </li>
                  ))}
                </ul>
                <button 
                  style={{ ...s.pricingBtn, ...(p.popular ? { ...s.pricingBtnPopular, background: p.color } : {}) }} 
                  className="pricing-btn"
                  onClick={openTg}
                >
                  <i className="fas fa-cart-plus" style={{ marginRight: 8 }}></i>
                  ជ្រើសរើស
                </button>
              </div>
            ))}
          </div>
          <div style={s.pricingNote}>
            <i className="fas fa-info-circle" style={{ marginRight: 8, color: BLUE }}></i>
            អាចប្ដូរកញ្ចប់តាមតម្រូវការបានគ្រប់ពេល · ការគាំទ្រ ២៤/៧
          </div>
        </div>
      </section>

      {/* ══════════ CTA ══════════ */}
      <section style={s.cta}>
        <div style={s.ctaBg}>
          <div style={s.ctaGlow}></div>
        </div>
        <div style={{ maxWidth: 700, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 2 }}>
          <span style={s.ctaBadge}>🚀 ត្រៀមហើយ?</span>
          <h2 style={s.ctaTitle}>
            ចាប់ផ្តើមអាជីវកម្មឌីជីថល<br />
            <span style={{ color: BLUE }}>ឥឡូវនេះ</span> ដោយឥតគិតថ្លៃ
          </h2>
          <p style={s.ctaSub}>គ្មានកាតឥណទាន · គ្មានការសាកល្បង · ចាប់ផ្តើមភ្លាម</p>
          <button
            style={{ ...s.btnBlue, padding: '16px 48px', fontSize: 18, borderRadius: 12 }}
            className="btn-blue"
            onClick={openTg}
          >
            <i className="fab fa-telegram-plane" style={{ marginRight: 10 }}></i>
            ទំនាក់ទំនងឥឡូវនេះ
          </button>
        </div>
      </section>

      {/* ══════════ FOOTER ══════════ */}
      <footer style={s.footer}>
        <div style={s.footerInner}>
          <div style={s.footerTop}>
            <div style={s.footerBrand}>
              <span style={s.brandDot} />
              <span style={{ color: '#fff', fontSize: 18, fontWeight: 700 }}>Menu Khmer Digital</span>
              <p style={s.footerDesc}>វេទិកាម៉ឺនុយឌីជីថលសម្រាប់អាជីវកម្មខ្មែរ</p>
            </div>
            <div style={s.footerLinks}>
              <div>
                <h4 style={s.footerHeading}>តំណភ្ជាប់</h4>
                <Link to="/demo_store1" style={s.footerLink}>ហាងសាកល្បង</Link>
                <Link to="#pricing" style={s.footerLink}>តម្លៃ</Link>
                <button style={s.footerLink} onClick={openTg}>ទំនាក់ទំនង</button>
              </div>
              <div>
                <h4 style={s.footerHeading}>ទំនាក់ទំនង</h4>
                <a href="https://t.me/thymuoyhak" style={s.footerLink} target="_blank" rel="noopener">Telegram</a>
                <a href="#" style={s.footerLink}>Facebook</a>
                <a href="#" style={s.footerLink}>Instagram</a>
              </div>
            </div>
          </div>
          <div style={s.footerBottom}>
            <span style={s.footCopy}>© ២០២៤ Menu Khmer Digital. រក្សាសិទ្ធិគ្រប់យ៉ាង</span>
            <div style={{ display: 'flex', gap: 20 }}>
              <a href="#" style={s.footLink}>គោលការណ៍ឯកជន</a>
              <a href="#" style={s.footLink}>លក្ខខណ្ឌប្រើប្រាស់</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

/* ─────────────────────────────────────────
   STYLES
───────────────────────────────────────── */
const s = {
  root: {
    fontFamily: "'Kantumruy Pro', sans-serif",
    background: '#fff',
    color: NAVY,
    overflowX: 'hidden',
    minHeight: '100vh',
  },

  nav: {
    position: 'sticky', top: 0, zIndex: 100,
    background: 'rgba(255,255,255,0.95)',
    backdropFilter: 'blur(12px)',
    transition: 'box-shadow .3s, border-bottom .3s',
  },
  navInner: {
    maxWidth: 1200, margin: '0 auto',
    padding: '0 24px', height: 64,
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  brand: {
    fontSize: 18, fontWeight: 700, color: NAVY,
    textDecoration: 'none',
    display: 'flex', alignItems: 'center', gap: 10,
  },
  brandName: {
    fontSize: 16,
  },
  brandDot: {
    display: 'inline-block',
    width: 10, height: 10, borderRadius: '50%',
    background: BLUE,
    flexShrink: 0,
  },
  navRight: { display: 'flex', alignItems: 'center', gap: 16 },
  navLink: {
    color: '#64748b', textDecoration: 'none', fontSize: 14,
    transition: 'color .2s',
    fontWeight: 500,
  },

  btnBlue: {
    background: BLUE, color: '#fff',
    border: 'none', padding: '10px 24px',
    borderRadius: 10, cursor: 'pointer',
    fontSize: 14, fontWeight: 600,
    fontFamily: "'Kantumruy Pro', sans-serif",
    textDecoration: 'none', display: 'inline-flex',
    alignItems: 'center', justifyContent: 'center',
    transition: 'transform .2s, box-shadow .2s',
    lineHeight: 1.4,
  },
  btnGhost: {
    background: 'transparent',
    color: 'rgba(255,255,255,.9)',
    border: '1.5px solid rgba(255,255,255,.3)',
    padding: '10px 24px', borderRadius: 10,
    cursor: 'pointer', fontSize: 14,
    fontFamily: "'Kantumruy Pro', sans-serif",
    textDecoration: 'none', display: 'inline-flex',
    alignItems: 'center',
    transition: 'border-color .2s, color .2s',
    lineHeight: 1.4,
  },

  hero: {
    background: NAVY,
    position: 'relative',
    overflow: 'hidden',
  },
  heroBg: {
    position: 'absolute',
    inset: 0,
    overflow: 'hidden',
  },
  heroGlow1: {
    position: 'absolute',
    width: '600px', height: '600px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(37,99,235,0.15) 0%, transparent 70%)',
    top: '-200px', right: '-100px',
  },
  heroGlow2: {
    position: 'absolute',
    width: '400px', height: '400px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(6,182,212,0.1) 0%, transparent 70%)',
    bottom: '-100px', left: '-100px',
  },
  heroInner: {
    maxWidth: 1200, margin: '0 auto',
    padding: '60px 24px 40px',
    display: 'flex', gap: 60, alignItems: 'center',
    position: 'relative',
    zIndex: 1,
  },
  heroLeft: { flex: 1, minWidth: 0 },
  heroBadge: {
    display: 'inline-block',
    background: 'rgba(37,99,235,.15)',
    border: '1px solid rgba(37,99,235,.3)',
    color: BLUE, borderRadius: 100,
    padding: '6px 16px', fontSize: 12,
    fontWeight: 600, marginBottom: 24,
  },
  h1: {
    fontFamily: "'Hanuman', serif",
    fontSize: 'clamp(36px, 4.5vw, 56px)',
    fontWeight: 900, lineHeight: 1.25,
    color: '#fff', marginBottom: 16,
  },
  heroSub: {
    fontSize: 16, color: 'rgba(255,255,255,.7)',
    lineHeight: 1.9, marginBottom: 32,
    maxWidth: 500,
  },
  heroBtns: { display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24 },
  heroTrust: {
    display: 'flex', gap: 20,
    color: 'rgba(255,255,255,.5)',
    fontSize: 13,
    flexWrap: 'wrap',
  },

  heroRight: { width: 340, flexShrink: 0 },
  demoCard: {
    background: '#fff', borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0,0,0,.3)',
  },
  demoCardHeader: {
    padding: '14px 20px',
    borderBottom: '1px solid #f1f5f9',
    display: 'flex', alignItems: 'center', gap: 12,
  },
  demoDots: {
    display: 'flex', gap: 6,
    '& span': {
      width: 10, height: 10, borderRadius: '50%',
      display: 'inline-block',
    },
  },
  demoCardTitle: {
    fontSize: 13, fontWeight: 600, color: NAVY,
  },
  demoCardBody: {
    padding: 20,
  },
  demoItem: {
    display: 'flex', justifyContent: 'space-between',
    padding: '10px 0', borderBottom: '1px solid #f1f5f9',
    fontSize: 14,
  },
  demoTotal: {
    display: 'flex', justifyContent: 'space-between',
    padding: '14px 0',
    fontSize: 16, fontWeight: 700, color: NAVY,
  },
  demoBtn: {
    width: '100%', padding: '12px',
    background: BLUE, border: 'none', borderRadius: 10,
    color: '#fff', fontFamily: "'Kantumruy Pro', sans-serif",
    fontSize: 14, fontWeight: 600, cursor: 'pointer',
    transition: 'opacity .2s',
  },

  statsBar: {
    borderTop: `2px solid rgba(37,99,235,.2)`,
    background: 'rgba(0,0,0,.2)',
    position: 'relative',
    zIndex: 1,
  },
  statsInner: {
    maxWidth: 1200, margin: '0 auto',
    padding: '0 24px',
    display: 'flex', flexWrap: 'wrap',
  },
  statItem: {
    flex: 1, padding: '24px 16px', textAlign: 'center',
    minWidth: 120,
    borderRight: '1px solid rgba(255,255,255,.05)',
  },
  statIcon: {
    fontSize: 28, display: 'block', marginBottom: 4, color: BLUE,
  },
  statNum: {
    fontFamily: "'Hanuman', serif",
    fontSize: 28, fontWeight: 900,
    color: BLUE, lineHeight: 1, marginBottom: 4,
  },
  statLbl: { fontSize: 12, color: 'rgba(255,255,255,.5)' },

  section: { padding: '80px 0' },
  container: { maxWidth: 1200, margin: '0 auto', padding: '0 24px' },
  eyebrow: {
    fontSize: 11, letterSpacing: '.2em', color: BLUE,
    fontWeight: 700, marginBottom: 8, textTransform: 'uppercase',
  },
  h2: {
    fontFamily: "'Hanuman', serif",
    fontSize: 'clamp(28px, 3.5vw, 40px)',
    fontWeight: 900, color: NAVY,
    marginBottom: 48, lineHeight: 1.2,
  },

  stepsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 24,
  },
  stepCard: {
    position: 'relative',
    padding: '32px 24px',
    background: '#fff',
    borderRadius: 16,
    border: '1px solid #e2e8f0',
    textAlign: 'center',
    transition: 'all .3s',
  },
  stepNumber: {
    fontSize: 14, fontWeight: 700, color: BLUE,
    marginBottom: 12,
  },
  stepIcon: {
    fontSize: 32, marginBottom: 12, color: BLUE,
  },
  stepTitle: {
    fontFamily: "'Hanuman', serif",
    fontSize: 18, fontWeight: 700,
    color: NAVY, marginBottom: 8,
  },
  stepDesc: { fontSize: 13, color: '#64748b', lineHeight: 1.6 },
  stepArrow: {
    display: 'none',
  },

  grid3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 24,
  },
  featCard: {
    padding: '32px 24px',
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    transition: 'all .3s',
  },
  featIcon: {
    fontSize: 36, marginBottom: 16, color: BLUE,
  },
  featTitle: {
    fontFamily: "'Hanuman', serif",
    fontSize: 18, fontWeight: 700,
    color: NAVY, marginBottom: 8,
  },
  featDesc: { fontSize: 14, color: '#64748b', lineHeight: 1.8 },

  testimonialsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: 24,
  },
  testimonialCard: {
    padding: '28px 24px',
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    transition: 'all .3s',
  },
  testimonialStars: {
    marginBottom: 12,
    fontSize: 18,
  },
  testimonialText: {
    fontSize: 14, color: '#475569',
    lineHeight: 1.8, marginBottom: 16,
    fontStyle: 'italic',
  },
  testimonialAuthor: {
    display: 'flex', alignItems: 'center', gap: 12,
  },
  testimonialAvatar: {
    width: 40, height: 40, borderRadius: '50%',
    background: BLUE, color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: 700, fontSize: 16,
  },
  testimonialName: {
    fontSize: 14, fontWeight: 600, color: NAVY,
  },
  testimonialRole: {
    fontSize: 12, color: '#94a3b8',
  },

  pricingGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: 24,
    alignItems: 'stretch',
  },
  pricingCard: {
    padding: '32px 24px',
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    textAlign: 'center',
    transition: 'all .3s',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  pricingCardPopular: {
    border: `2px solid ${BLUE}`,
    transform: 'scale(1.02)',
    boxShadow: '0 8px 30px rgba(37,99,235,.15)',
  },
  popularBadge: {
    position: 'absolute',
    top: -12, left: '50%',
    transform: 'translateX(-50%)',
    background: BLUE, color: '#fff',
    padding: '4px 16px', borderRadius: 100,
    fontSize: 11, fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  pricingIcon: {
    fontSize: 28, marginBottom: 8,
  },
  pricingName: {
    fontSize: 18, fontWeight: 700, color: NAVY,
    marginBottom: 4,
  },
  pricingPrice: {
    fontSize: 36, fontWeight: 900, color: NAVY,
  },
  pricingPer: {
    fontSize: 13, color: '#94a3b8',
    marginBottom: 4,
  },
  pricingProducts: {
    fontSize: 14, fontWeight: 600,
    marginBottom: 16,
    padding: '4px 16px',
    borderRadius: 100,
    display: 'inline-block',
  },
  pricingFeatures: {
    listStyle: 'none', padding: 0, margin: '16px 0 24px',
    textAlign: 'left',
    flex: 1,
  },
  pricingFeature: {
    fontSize: 13, color: '#475569',
    padding: '6px 0',
    display: 'flex', alignItems: 'center',
  },
  pricingBtn: {
    width: '100%', padding: '12px',
    background: '#f1f5f9', color: NAVY,
    border: 'none', borderRadius: 10,
    fontSize: 14, fontWeight: 600, cursor: 'pointer',
    fontFamily: "'Kantumruy Pro', sans-serif",
    transition: 'all .2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 'auto',
  },
  pricingBtnPopular: {
    background: BLUE, color: '#fff',
  },
  pricingNote: {
    textAlign: 'center',
    marginTop: 24,
    fontSize: 14,
    color: '#64748b',
    padding: '12px 24px',
    background: '#fff',
    borderRadius: 12,
    border: '1px solid #e2e8f0',
  },

  cta: {
    background: NAVY,
    padding: '80px 24px',
    position: 'relative',
    overflow: 'hidden',
  },
  ctaBg: {
    position: 'absolute',
    inset: 0,
  },
  ctaGlow: {
    position: 'absolute',
    width: '500px', height: '500px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(37,99,235,0.15) 0%, transparent 70%)',
    top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  ctaBadge: {
    display: 'inline-block',
    background: 'rgba(37,99,235,.15)',
    color: BLUE,
    padding: '4px 16px', borderRadius: 100,
    fontSize: 12, fontWeight: 600,
    marginBottom: 16,
  },
  ctaTitle: {
    fontFamily: "'Hanuman', serif",
    fontSize: 'clamp(28px, 4vw, 44px)',
    fontWeight: 900, color: '#fff',
    lineHeight: 1.3, marginBottom: 14,
  },
  ctaSub: {
    fontSize: 14, color: 'rgba(255,255,255,.5)',
    marginBottom: 32,
  },

  footer: {
    background: NAVYD,
    borderTop: `1px solid rgba(37,99,235,.2)`,
    padding: '40px 0 24px',
  },
  footerInner: {
    maxWidth: 1200, margin: '0 auto', padding: '0 24px',
  },
  footerTop: {
    display: 'flex', justifyContent: 'space-between',
    flexWrap: 'wrap', gap: 32,
    marginBottom: 32,
  },
  footerBrand: {
    maxWidth: 280,
  },
  footerDesc: {
    fontSize: 13, color: 'rgba(255,255,255,.4)',
    marginTop: 8, lineHeight: 1.6,
  },
  footerLinks: {
    display: 'flex', gap: 40,
    flexWrap: 'wrap',
  },
  footerHeading: {
    fontSize: 13, fontWeight: 600, color: '#fff',
    marginBottom: 12,
  },
  footerLink: {
    display: 'block', fontSize: 13,
    color: 'rgba(255,255,255,.4)',
    textDecoration: 'none', background: 'none', border: 'none',
    padding: '4px 0', cursor: 'pointer', fontFamily: "'Kantumruy Pro', sans-serif",
    transition: 'color .2s',
  },
  footerBottom: {
    borderTop: '1px solid rgba(255,255,255,.06)',
    paddingTop: 16,
    display: 'flex', justifyContent: 'space-between',
    flexWrap: 'wrap', gap: 12,
  },
  footCopy: {
    fontSize: 12, color: 'rgba(255,255,255,.3)',
  },
  footLink: {
    fontSize: 12, color: 'rgba(255,255,255,.3)',
    textDecoration: 'none', transition: 'color .2s',
  },
};

/* ─────────────────────────────────────────
   GLOBAL CSS
───────────────────────────────────────── */
const GLOBAL = `
  @import url('https://fonts.googleapis.com/css2?family=Hanuman:wght@700;900&family=Kantumruy+Pro:wght@300;400;600;700&display=swap');
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  @keyframes spin  { to { transform: rotate(360deg); } }
  @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.3} }

  .btn-blue:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(37,99,235,.35) !important;
  }
  .btn-blue:active { transform: scale(.97); }
  .btn-ghost:hover { border-color: ${BLUE} !important; color: ${BLUE} !important; }
  .demo-btn:hover { opacity: .9; }
  .nav-link:hover { color: ${NAVY} !important; }

  .feat-card:hover {
    border-color: ${BLUE} !important;
    box-shadow: 0 8px 30px rgba(37,99,235,.08) !important;
    transform: translateY(-4px);
  }
  .step-card:hover {
    border-color: ${BLUE} !important;
    box-shadow: 0 8px 30px rgba(37,99,235,.08) !important;
    transform: translateY(-4px);
  }
  .testimonial-card:hover {
    border-color: ${BLUE} !important;
    box-shadow: 0 8px 30px rgba(37,99,235,.08) !important;
  }
  .pricing-card:hover {
    border-color: ${BLUE} !important;
    box-shadow: 0 8px 30px rgba(37,99,235,.08) !important;
  }
  .pricing-card.popular:hover {
    box-shadow: 0 8px 40px rgba(37,99,235,.2) !important;
  }
  .pricing-btn:hover { opacity: .9; transform: translateY(-2px); }
  .footer-link:hover { color: #fff !important; }
  .foot-link:hover { color: #fff !important; }

  @media (max-width: 768px) {
    .hero-inner { flex-direction: column !important; text-align: center; }
    .hero-right { width: 100% !important; max-width: 360px; margin: 0 auto; }
    .hero-sub { margin-left: auto; margin-right: auto; }
    .hero-trust { justify-content: center; }
    .stats-inner { flex-wrap: wrap; }
    .stat-item { flex: 1 1 50%; border-right: none !important; border-bottom: 1px solid rgba(255,255,255,.05); }
    .pricing-card.popular { transform: scale(1); }
    .footer-top { flex-direction: column; }
  }
  @media (max-width: 600px) {
    .nav-inner { padding: 0 16px !important; }
    .container { padding: 0 16px !important; }
    .hero-inner { padding: 40px 16px 24px; }
    .h1 { font-size: clamp(28px, 8vw, 36px); }
    .pricing-grid { grid-template-columns: 1fr; }
    .pricing-card.popular { transform: scale(1); }
  }
`;